import React from 'react'

const CancelationPolicy = () => {
  return (
    <div></div>
  )
}

export default CancelationPolicy